import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import FormError from "./FormError";
import api from "../api";

export default function StatusChangeDialog({
  open,
  onClose,
  onSave,
  statementId
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleMarkAsPaid = () => {
    setLoading(true);
    api
      .markStatementAsPaid({ id: statementId })
      .then(api.pickData)
      .then((data) => {
        setLoading(false);
        onSave(data);
      })
      .catch((err) => {
        setError(err.message || "Failed to mark statement as paid");
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Mark Statement as Paid</DialogTitle>
      <DialogContent>
        {loading ? (
          <div
            style={{ display: "flex", justifyContent: "center", padding: 20 }}
          >
            <CircularProgress />
          </div>
        ) : (
          <Typography>
            Are you sure you want to mark this statement as paid? This action
            cannot be undone.
          </Typography>
        )}

        {error && <FormError error={error} resetError={() => setError(null)} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleMarkAsPaid}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          Mark as Paid
        </Button>
      </DialogActions>
    </Dialog>
  );
}
